module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isActive) ? _c('section', {
    staticClass: "tab-item",
    attrs: {
      "role": "tabpanel"
    }
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1fad2501!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tab.vue
// module id = 130
// module chunks = 1